import React from 'react';
import { FileUp, Link as LinkIcon, X } from 'lucide-react';

export function FileUploadSection({ 
  fileUrl, 
  fileName, 
  fileSize, 
  uploading, 
  uploadError,
  onFileUpload,
  onUrlSubmit,
  onRemove
}) {
  return (
    <div>
      <label className="block text-sm font-medium text-foreground mb-2">
        Attach File (Optional)
      </label>
      
      {!fileUrl ? (
        <>
          <div className="grid grid-cols-2 gap-3 mb-3">
            <label className="px-4 py-3 bg-surface border border-border rounded-lg text-foreground hover:bg-surface-hover transition-colors cursor-pointer text-center flex items-center justify-center gap-2">
              <FileUp className="w-4 h-4" />
              <span className="text-sm">Upload file</span>
              <input
                type="file"
                onChange={onFileUpload}
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                className="hidden"
                disabled={uploading}
              />
            </label>

            <button
              type="button"
              onClick={() => {
                const url = prompt('Paste a link (Google Drive, Dropbox, etc.):');
                if (url) {
                  onUrlSubmit(url);
                }
              }}
              className="px-4 py-3 bg-surface border border-border rounded-lg text-foreground hover:bg-surface-hover transition-colors flex items-center justify-center gap-2"
            >
              <LinkIcon className="w-4 h-4" />
              <span className="text-sm">Paste link</span>
            </button>
          </div>

          {uploading && <p className="text-sm text-primary">Uploading...</p>}
          {uploadError && <p className="text-sm text-red-500">{uploadError}</p>}
        </>
      ) : (
        <div className="bg-surface border border-border rounded-lg p-3 flex items-center justify-between">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <LinkIcon className="w-4 h-4 text-primary flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground truncate">{fileName}</p>
              {fileSize && <p className="text-xs text-text-muted">{fileSize}</p>}
            </div>
          </div>
          <button
            type="button"
            onClick={onRemove}
            className="p-1 hover:bg-background rounded transition-colors flex-shrink-0"
          >
            <X className="w-4 h-4 text-text-muted" />
          </button>
        </div>
      )}
    </div>
  );
}
